<ng-container *appI18nScopeReady>
  <h2 mat-dialog-title>{{ 'title' | i18n }}</h2>

  <mat-dialog-content>
    <div class="form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'name_label' | i18n }}</mat-label>
        <input
          matInput
          [(ngModel)]="name"
          [placeholder]="'name_placeholder' | i18n"
          (keydown.enter)="apply()"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'description_label' | i18n }}</mat-label>
        <textarea
          matInput
          [(ngModel)]="description"
          [placeholder]="'description_placeholder' | i18n"
          rows="3"
        ></textarea>
      </mat-form-field>

      <div class="submitted-edit-group">
        <mat-slide-toggle [(ngModel)]="allowEditSubmittedRows" color="primary">
          <span class="label-with-help">
            <span>{{ 'allow_edit_submitted_rows_label' | i18n }}</span>
            <mat-icon
              class="label-help-icon"
              [matTooltip]="'allow_edit_submitted_rows_note' | i18n"
              matTooltipPosition="above"
            >info</mat-icon>
          </span>
        </mat-slide-toggle>
      </div>

      <section class="config-section">
        <h3 class="section-title">{{ 'ingestion_section_title' | i18n }}</h3>
        <div class="timezone-group">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label class="label-with-help">
              <span>{{ 'timezone_label' | i18n }}</span>
              <mat-icon
                class="label-help-icon"
                [matTooltip]="'timezone_import_utc_note' | i18n"
                matTooltipPosition="above"
              >info</mat-icon>
            </mat-label>
            <mat-select [(ngModel)]="timezone" [disabled]="true">
              <mat-option [value]="timezone">{{ timezone }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'timestamp_field_label' | i18n }}</mat-label>
          <input
            matInput
            [(ngModel)]="timestampField"
            [placeholder]="'timestamp_field_placeholder' | i18n"
          />
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label class="label-with-help">
            <span>{{ 'duplicate_handling_label' | i18n }}</span>
            <mat-icon
              class="label-help-icon"
              [matTooltip]="'duplicate_handling_note' | i18n"
              matTooltipPosition="above"
            >info</mat-icon>
          </mat-label>
          <mat-select [(ngModel)]="duplicateHandling">
            @for (option of duplicateHandlingOptions; track option) {
              <mat-option [value]="option">
                {{ ('duplicate_handling_' + option) | i18n }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="period-group">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label class="label-with-help">
              <span>{{ 'period_label' | i18n }}</span>
              <mat-icon
                class="label-help-icon"
                [matTooltip]="'period_behavior_note' | i18n"
                matTooltipPosition="above"
              >info</mat-icon>
            </mat-label>
            <mat-select [(ngModel)]="period">
              @for (option of periodOptions; track option) {
                <mat-option [value]="option">
                  {{ ('period_' + option) | i18n }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </section>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" mat-icon-button class="delete-btn" (click)="requestDelete()">
      <mat-icon>delete</mat-icon>
    </button>
    <span class="actions-spacer"></span>
    <button type="button" mat-button (click)="cancel()">
      {{ 'cancel' | i18n }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="!isValid"
      (click)="apply()"
    >
      {{ 'save' | i18n }}
    </button>
  </mat-dialog-actions>
</ng-container>
